<app-header headerText="Lista De Préstamos Pendientes"></app-header>

<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true>

  <mat-tab>

    <ng-template mat-tab-label>
      <mat-icon>timer</mat-icon>
      Pendientes<br>&nbsp;
    </ng-template>

    <h5 class="mt-5 text-center">Selecciona el tipo de caja para ver la lista de tus préstamos pendientes
    </h5>
    <div *ngIf="pendingList.length && periods.length">

      <div class="row py-2 border-bottom">
        <div class="col-md-4 offset-md-4">
          <mat-form-field>
            <mat-select placeholder="Ver Ciclo de Ahorro:" (selectionChange)="selectedPeriodChange($event)">
              <mat-option>Seleccione Un Tipo</mat-option>
              <mat-option *ngFor="let loanType of loanTypes" [value]="loanType">
                {{loanType.title}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <!--div class="row ng-star-inserted" *ngIf="selectedList.length > 0; else nothingSearch">
        <div class="col-md-4 offset-md-8">
          <mat-form-field class="example-full-width">
            <input matInput placeholder="Búsqueda:" [value]="stateSearchBox.query" (keyup)="applyFilter($event.target.value)">
          </mat-form-field>
        </div>
      </div-->

      <div class="row mt-4" *ngIf="selectedList.length > 0; else nothingSelected">
        <div class="col-md-12">

          <mat-table [dataSource]="selectedList" matSort class="table border">

            <ng-container matColumnDef="index">
              <mat-header-cell *matHeaderCellDef> Index </mat-header-cell>
              <mat-cell *matCellDef="let element; let i = index;">{{i + 1}}</mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Status:</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.status}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="employeeNumber">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Número De<br>Colaborador:</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.employeeRef.employeeNumber}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="email">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Correo<br>Electrónico:</mat-header-cell>
              <mat-cell *matCellDef="let element">
                {{ element.employeeRef.email ? element.employeeRef.email : 'Sin Correo' }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="username">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Nombre:</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.employeeRef.displayName }} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdAt">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Fecha:</mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.createdAt | date:'d-MMM-y h:mm:ss a'}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="details" class="center-text">
              <mat-header-cell *matHeaderCellDef><span>Autorizar</span></mat-header-cell>
              <mat-cell *matCellDef="let element">

                <button mat-icon-button color="primary" [routerLink]="['loan-approval', element.loanID]">
                  <span>Ver Solicitud</span>
                </button>

              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </mat-table>


        </div>
      </div>

      <ng-template #nothingSearch>

        <div class="row mt-4">
          <div class="col-md-12 text-center noActions">
            <h5>No hay préstamos pendientes con esta busqueda.</h5>
          </div>
        </div>

      </ng-template>

      <ng-template #nothingSelected>

        <div class="row mt-4" *ngIf="!selectedList.length">
          <div class="col-md-12 text-center noActions">
            <mat-icon aria-hidden="true">search</mat-icon>
            <h5>Seleccione Un Periodo</h5>
          </div>
        </div>

      </ng-template>

    </div>

    <div class="row mt-4" *ngIf="periods.length == 0; else emptyBox">
      <div class="col-md-12 text-center noActions">
        <mat-icon aria-hidden="true">timer</mat-icon>
        <h5>Cargando información...</h5>
      </div>
    </div>

    <ng-template #emptyBox>

      <div class="row mt-4" *ngIf="!pendingList.length">
        <div class="col-md-12 text-center noActions">
          <mat-icon aria-hidden="true">check</mat-icon>
          <h5>No Hay Préstamos Pendientes Para Aprobación En Este Momento</h5>
        </div>
      </div>
    </ng-template>


  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <mat-icon>clear</mat-icon>
      Negados<br>&nbsp;
    </ng-template>

    <div class="row mt-4" *ngIf="deniedList.length">

      <div class="col-md-12">

        <mat-table [dataSource]="deniedList" matSort class="table border">

          <ng-container matColumnDef="employeeNumber">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Número De<br>Colaborador:</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.employeeRef.employeeNumber}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Correo<br>Electrónico:</mat-header-cell>
            <mat-cell *matCellDef="let element">
              {{ element.employeeRef.email ? element.employeeRef.email : 'Sin Correo' }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="username">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Nombre:</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.employeeRef.displayName }} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Fecha:</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.createdAt | date:'d-MMM-y h:mm:ss a'}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="details" class="center-text">
            <mat-header-cell *matHeaderCellDef><span>Detalles</span></mat-header-cell>
            <mat-cell *matCellDef="let element">

              <button mat-icon-button color="primary" [routerLink]="['loan-approval', element.loanID]">
                <mat-icon aria-label="approve">info</mat-icon>
              </button>

            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedDeniedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedDeniedColumns;"></mat-row>

        </mat-table>

      </div>

    </div>

  </mat-tab>

</mat-tab-group>
